<template>
  <h-f-filter-wrapper :active-filter="filterInstance.active" :form-filter="filterInstance.form">
    <div v-for="(filter, index) in filterSpecs.filters" :key="index">
      <h-f-filter
        v-model="filterInstance.active[filter.model]"
        :number="0"
        :title="filter.title"
        v-bind="filter.layout"
      >
        <component
          :is="filter.component"
          v-model="filterInstance.form[filter.model]"
          :label="filter.label"
          v-bind="filter.customAttributes"
          :class="filter.class"
          :options="filter.options"
          :input-type="filter.inputType"
        >
          <div v-if="filter.insideLabel">
            {{ filter.label }}
          </div>
        </component>
      </h-f-filter>
    </div>
  </h-f-filter-wrapper>
</template>
<script>
/*
  Auto-filter component

*/

export default {
  name: 'auto-filter',
  props: {
    filterSpecs: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterInstance: this.value,
    }
  },

  watch: {
    filterInstance: {
      deep: true,
      async handler() {
        const filterInstanceForm = Object.keys(this.filterInstance.form)
        for (let i = 0; i < filterInstanceForm.length; i++) {
          const key = filterInstanceForm[i]
          if (typeof this.filterInstance.form[key] === 'object' && this.filterInstance.form[key] !== null) {
            if (this.filterInstance.form[key].start && this.filterInstance.form[key].end) {
              this.filterInstance.form[`${key}_after`] = `${this.filterInstance.form[key].start}`
              this.filterInstance.form[`${key}_before`] = `${this.filterInstance.form[key].end}`
              this.filterInstance.active[`${key}_after`] = this.filterInstance.active[key]
              this.filterInstance.active[`${key}_before`] = this.filterInstance.active[key]
            }
          }
        }
        this.$emit('change', this.filterInstance)
      },
    },
    value() {
      this.filterInstance = this.value
    },
  },
  methods: {},
}
</script>

<style scoped></style>
